import axios from 'axios';
import { API_URL } from '../config';

/**
 * Switch Utenze - API layer.
 *
 * Endpoints live on the aziende host, same as `login`/`whoami` (`API_URL` already
 * ends with `/api`). The auth header is the RAW token, without the `Bearer` prefix,
 * exactly like every other call in this codebase.
 */

/**
 * GET /api/dipendenti/find-same-credentials
 * Returns the other employee accounts that share the current credentials:
 * { total_matches, employees: [{ first_name, last_name, company: { id, business_name } }], ... }
 */
export const findSameCredentials = async (token: string) => {
  if (!token) throw new Error('Token is required');

  const response = await axios.get(`${API_URL}/dipendenti/find-same-credentials`, {
    headers: {
      Authorization: `${token}`,
    },
  });
  return response.data;
};

/**
 * POST /api/dipendenti/login-as-yourself  body: { company_id }
 * Returns a fresh session for the target company. We only rely on the `token`
 * field; the full profile is re-hydrated afterwards via `whoami` (`/api/me`).
 */
export const loginAsYourself = async (token: string, companyId: number | string) => {
  if (!token) throw new Error('Token is required');
  if (!companyId) throw new Error('Company ID is required');

  const response = await axios.post(
    `${API_URL}/dipendenti/login-as-yourself`,
    { company_id: companyId },
    {
      headers: {
        Authorization: `${token}`,
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
};
